import { Link } from 'gatsby';
import React from 'react';

import Layout from '../components/layouts/main';
import SEO from '../components/layouts/seo';

const classes = {
  title: 'text-lg font-bold',
  link: 'underline',
};

const NotFoundPage = ({ location }) => (
  <Layout>
    <SEO title="Not found" location={location} />
    <h1 className={classes.title}>404: Not Found</h1>
    <p>
      You just hit a route that doesn't exist.{' '}
      <Link className={classes.link} to="/">
        Return to safety
      </Link>
      .
    </p>
  </Layout>
);

export default NotFoundPage;
